module.exports = __webpack_public_path__ + "d86d5ba5c2bbbb99985aca0aa0ad23be.png";